const MEDIA_ITEMS = [
  {
    id: 1,
    image: 'https://readdy.ai/api/search-image?query=Entertainment%20news%20video%20thumbnail%20style%2C%20dramatic%20celebrity%20scene%2C%20warm%20lighting%2C%20editorial%20photography%2C%20coral%20and%20amber%20tones%2C%20professional%20video%20production%20aesthetic&width=640&height=360&seq=media-01&orientation=landscape',
    title: '明星恋情实锤全记录：从偶遇到官宣',
    duration: '15:28',
    views: '128.5万',
    tag: '明星八卦',
  },
  {
    id: 2,
    image: 'https://readdy.ai/api/search-image?query=Influencer%20controversy%20video%20thumbnail%2C%20dramatic%20moment%2C%20warm%20tone%2C%20social%20media%20drama%20visualization%2C%20professional%20production%20style&width=640&height=360&seq=media-02&orientation=landscape',
    title: '网红翻车现场：直播中的惊天爆料',
    duration: '22:15',
    views: '96.8万',
    tag: '网红翻车',
  },
  {
    id: 3,
    image: 'https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20TV%20show%20production%2C%20mysterious%20atmosphere%2C%20warm%20dramatic%20lighting%2C%20entertainment%20industry%20documentary%20style&width=640&height=360&seq=media-03&orientation=landscape',
    title: '综艺后台未播出片段独家曝光',
    duration: '18:42',
    views: '83.2万',
    tag: '综艺内幕',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 bg-accent-100 text-accent-700 text-xs font-semibold rounded-full mb-4 whitespace-nowrap">
            视频中心
          </span>
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">
            精彩视频
          </h2>
          <p className="text-sm text-foreground-500 mt-3">吃瓜也要有声有色</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {MEDIA_ITEMS.map((item) => (
            <div
              key={item.id}
              className="group bg-background-100 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200/60 transition-all duration-200 cursor-pointer flex flex-col"
            >
              <div className="relative overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full aspect-video object-cover group-hover:scale-105 transition-transform duration-500"
                  width="640"
                  height="360"
                />
                <div className="absolute inset-0 bg-foreground-900/20 group-hover:bg-foreground-900/30 transition-colors flex items-center justify-center">
                  <div className="w-14 h-14 flex items-center justify-center rounded-full bg-background-50/90 group-hover:scale-110 transition-transform duration-300">
                    <i className="ri-play-fill text-primary-500 text-2xl ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute bottom-3 right-3 text-[11px] px-2 py-1 rounded bg-foreground-900/70 text-background-50 font-medium whitespace-nowrap">
                  {item.duration}
                </span>
                <span className="absolute top-3 left-3 text-[11px] px-2.5 py-1 rounded-full bg-background-50/90 text-foreground-700 font-medium whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <div className="p-4 flex flex-col gap-2 flex-1">
                <h3 className="text-sm font-semibold text-foreground-900 leading-snug line-clamp-2 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <div className="flex items-center gap-3 text-xs text-foreground-400">
                  <span><i className="ri-eye-line mr-1"></i>{item.views}</span>
                  <span><i className="ri-time-line mr-1"></i>{item.duration}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}